import { Component } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TypedModalRef } from "../../models/TypedModalRef";
import { ProjectService } from "../../services/project.service";
import {
    ProjectClient,
    GetProjectDetailsResponse,
    GetProjectListResponse,
    ProjectOverview,
} from "../../WebApiClient";
import { ComponentBase } from "../../models/ComponentBase";
import { ToastService } from "../../services/toast.service";

@Component({
    selector: "app-edit-template-projects-mondal",
    templateUrl: "./edit-template-projects-modal.component.html",
    styleUrls: ["./edit-template-projects-modal.component.scss"],
    standalone: false
})
export class EditTemplateProjectsModalComponent extends ComponentBase {
    private readonly resultsPerPage = 25;

    private response: GetProjectListResponse | undefined = undefined;
    public hasData = false;

    public isPageChangerVisible = false;
    public isNextPageEnabled = false;
    public isPreviousPageEnabled = false;

    public currentPageNum = 1;
    public currentPage: ProjectOverview[]|undefined;

    constructor(
        private readonly activeModal: NgbActiveModal,
        private readonly projectService: ProjectService,
        private readonly toastService: ToastService,
        private readonly projectClient: ProjectClient
    ) {
        super();
        let subscription = projectService
            .templates
            .subscribe((response) => {
                this.hasData = !!response;
                this.response = response;
                this.triggerSearch();
            });
        this.subscriptions.push(subscription);
    }

    cancel() {
        this.activeModal.dismiss("user cancelled");
    }

    static open(
        modalService: NgbModal
    ): TypedModalRef<
        EditTemplateProjectsModalComponent,
        GetProjectDetailsResponse
    > {
        let modal = modalService.open(EditTemplateProjectsModalComponent, {
            size: "lg",
            windowClass: "full-height-modal",
        });
        let modalComponent = <EditTemplateProjectsModalComponent>(
            modal.componentInstance
        );
        return new TypedModalRef(modal);
    }

    private _searchTerm: string = "";
    public get searchTerm() {
        return this._searchTerm;
    }
    public set searchTerm(val: string) {
        this._searchTerm = val;
        this.triggerSearch();
    }

    private triggerSearch() {
        this.currentPageNum = 1;
        this.updatePage();
    }

    private updatePage(){
        if (!this.response?.projects)
            return;
        const searchTerms = this.searchTerm
            ? this.searchTerm.split(/\s+/)
            : [];
        const filteredProjects = this.response.projects
            .filter(proj => searchTerms.every(st =>
                proj.name.includes(st)
                || proj.shipName.includes(st)
                || proj.voyageNumber.includes(st)
            ));
        this.currentPage = filteredProjects
            .slice(
                (this.currentPageNum - 1) * this.resultsPerPage,
                this.currentPageNum * this.resultsPerPage
            );
        this.isPageChangerVisible = filteredProjects.length > this.resultsPerPage;
        this.isNextPageEnabled = filteredProjects.length > (this.currentPageNum) * this.resultsPerPage;
        this.isPreviousPageEnabled = this.currentPageNum > 1;
    }

    public nextPage(){
        this.currentPageNum++;
        this.updatePage();
    }
    public previousPage(){
        this.currentPageNum--;
        this.updatePage();
    }

    public async load(ProjectId: string) {
        let project: GetProjectDetailsResponse;
        project = await this.projectClient
            .getProjectDetails(ProjectId)
            .toPromise();
        this.activeModal.close(project);
    }

    async delete(template: ProjectOverview) {
        const isSure = window.confirm(`Are you sure you want to delete the template "${template.name}"?`)
        if (!isSure)
            return;
        try {
            await this.projectService.deleteTemplate(template.id);
            this.toastService.add(
                "Template deleteed",
                `The template "${template.name}" was deleted`,
                "success"
            );
        } catch (e) {
            this.toastService.reportFailure("Could not delete template", e);
        }
    }
}
